// do these things only once
// even if you are using a history.js navigation

// imports --------------------------------------------------------------------
// import FixBody from '../js_vendor/FixBody.js';
import Fader from '../js_vendor/Fader.js';
import FoldOut from '../js_vendor/FoldOut.js';
import AnimateIt from '../js_vendor/AnimateIt.js';
import Switcher from '../js_vendor/Switcher.js';
import Split from '../js_vendor/Split.js';
import History from '../js_vendor/History.js';
import VtOutOfView from '../js_vendor/VtOutOfView.js';
import HorScroll from '../js_vendor/HorScroll.js';

import * as Vars from './0-vars.js';
import * as Page from './3-page.js';
import * as Resize from './4-resize.js';
import * as Scroll from './5-scroll.js';

// set user variables ---------------------------------------------------------
const vtDuration = Vars.transitionSlow * .5; // also change in view-transitions css

// set code variables ---------------------------------------------------------
export let transitionDelay;

// export let fixer;
export let fader;
export let outFolder;
export let animator;
export let smoothScrollInactive;
export let aim;
export let switcher;
export let splitter;
export let history;
export let vtOutOfView;
export let horScroller;

export let pageTypePrev = sessionStorage.getItem('pageType');
document.body.setAttribute('data-pagetype-prev', pageTypePrev);
sessionStorage.setItem('pageType', $pageType);

const browserColorEl = document.querySelector('.browser-color');

export const useHistoryNavigation = !(typeof $usePageTransitions !== 'undefined' && $usePageTransitions);

// once function --------------------------------------------------------------
export const initOnce = () => {
  // console.log('once', window.blPageTransition ? 'view-transition' : 'no view-transition');

  // safari delay should be after VT duration, because css transitions are buggy during VT
  splitter = new Split({
    wordHolderSelector: '.words, .heading--h1, .heading--h2, .heading--h3', // add to custom selectors: &:not(:has(.split)) { visibility: hidden; } 
    wordTiming: { delay: Vars.blSafari ? 400 : 0, stagger: 100 },
    textClass: 'fader fader--up fader--repeat',
    imgClass: 'fader fader--loader fader--repeat',
  });

  if (Vars.blViewTransitions) {
    // add || Vars.blFirefox if you have vt elements with fader--force
    transitionDelay = Vars.blSafari ? vtDuration : vtDuration - 0; // 200 before last transition end is kinda nice. Fixes safari css transition issue
  } else {
    transitionDelay = Vars.transitionDefault; // main fade-out duration if using history
  }

  // add Fader
  fader = new Fader({
    // mobileMq: '(orientation: portrait)',
    // fadeDur: 1000,
    stagger: 100,
    // preFadeResizeDur: 200,
    // afterLoadFunction: Resize.saveOffsets, 
    inViewFadeDelay: transitionDelay, // 200 before last transition end is kinda nice, also fixes safari css transition issue
    addStaggerToFaderDelay: false, // if true (default), stagger and data-fader-delay are added together
    fadeScrollersSelector: '.flap',
    // fadeHorizontally: true, // uncomment to take x axis into account. For sliders this can cause issues unless you call setFaders after the slider has moved. If you have a horizontal scroller, set fadeScrollersSelector to the scroller element
    // listenToScroll: false, // uncomment if scrolling shouldn't call fadeBlocks
    // ignoreVertIfClip: false, // uncomment if clip has a translate
    // checkVisibilityOnScroll: true, // uncomment if visibility changes without calling setFaders
    // getPosOnScroll: true, // uncomment if position changes without calling setFaders
  });

  switcher = new Switcher({
    // duration: 400, // set to --switcher-duration
    startCallback: observerBlocker,
    afterFadeOutCallback: switcherEl => {
      if (fader && typeof fader.fadeInHolderAgain === 'function') {
        fader.fadeInHolderAgain(switcherEl); // not needed for fader loading images, that is done in observerUnblocker
      }
    },
    afterResizeCallback: observerUnblocker,
  });

  switcher.init();

  // disable view-transition-name for elements outside viewport
  vtOutOfView = new VtOutOfView({
    selector: '[data-vt-name]', // should also have style="view-transition-name: your-name;"
  });

  // add FoldOut
  outFolder = new FoldOut({
    name: 'default',
    startCallback: observerBlocker,
    duringCallback: Scroll.setScroll,
    callback: observerUnblocker,
    // closeOthers: false,
    // transitionDuration: 600; // also change _fold-out.scss
    closeInOtherHolders: true,
  });

  outFolder.init();

  // add HorScroll
  horScroller = new HorScroll({
    // centerOnActiveElement: false,
  });

  if (Vars.blTouch) horScroller.init();
  // horScroller.init(); // only if buttons to scroll, because not all devices have horizontal scroll

  // add AnimateIt
  animator = new AnimateIt({
    // frameFunction: frameHandler,
  });

  animator.init();

  // slow scroll and mouse follower
  // if (typeof animator !== 'undefined') {
  //   // not on firefox if iframes are present
  //   // if (!Vars.blTouch && !Vars.blFirefox) {
  //   if (!Vars.blTouch) {
  //     const initSmoothScroll = () => {
  //       animator.smoothScroll({
  //         speed: 0.2,
  //         bounce: 1,
  //       });
  //     };

  //     if (history && typeof history.historyCheckWoocommerce === 'function') {
  //       if (!historyCheckWoocommerce(window.location.href)) initSmoothScroll();
  //     } else {
  //       initSmoothScroll();
  //     }
  //   }
  // }

  smoothScrollInactive = typeof animator === 'undefined' || typeof animator.scroller !== 'object';

  if (useHistoryNavigation) {
    history = new History({
      useCache: false,
      projectTitle: $baseTitle,
      viewTransitions: Vars.blViewTransitions,
      cookiesPrefix: (typeof Cookies !== 'undefined' && 'cookiesPrefix' in Cookies) ? Cookies.cookiesPrefix : 'lf-p2',
      setScrollTop: Scroll.setScrollTop,
      samePage: historySamePage, // called if the link is on the same page
      animateBefore: historyAnimateBefore, // do an animation add do a callback when done
      beforeSwitch: historyBeforeSwitch, // do stuff before replacing the content
      newContent: () => Page.setPage({prepareFaderForViewTransition: Vars.blViewTransitions}), // do stuff after replacing the content, calls observerUnblocker
      afterSetScroll: () => Page.setPageAfterSetScroll({prepareFaderForViewTransition: Vars.blViewTransitions}), // do stuff after setting the scroll, so after animations that depend on scroll are done
      loadEventDelay: 0, // also sets full loader line and removes html--loader
      resetLineDelay: 0 + Vars.transitionDefault,
    });

    history.init();
  } else {
    history = undefined;
  }

  // output name for devvers ----------------------------------
  console.log('%cSite by', 'color: #999; font-size: 16px; font-family: "Arial"; font-weight: bold; text-transform: uppercase;');
  console.log('%cLittle Fragments', 'color: #999; font-size: 24px; font-family: "Arial"; font-weight: bold; text-transform: uppercase;');
};

// functions -------------------------------------------------------------------
// for history -----------------------------------------------
const historySamePage = href => {
  // document.body.classList.remove('body--nav');

  if ($historySelector === '.popover') {
    Scroll.scrollAnimator.animateScrollTop(0, {element: document.querySelector('.popover')});
  } else {
    if (href.indexOf('#') === -1) {
      Scroll.scrollAnimator.animateScrollTop(0);
    } else if (smoothScrollInactive) {
      const anchorElement = document.getElementById(href.split('#')[1]);
      if (anchorElement) Scroll.scrollToEl(anchorElement);
    }
  }
};

const historyAnimateBefore = setDoneAnimating => {
  if (Vars.blViewTransitions) {
    setDoneAnimating();
  } else {
    setTimeout(setDoneAnimating, Vars.transitionSlow); // allow content to fade out, because there is no VT
  }
};

const historyBeforeSwitch = () => {
  // document.body.classList.remove('body--nav');

  // removes selector from old page so it doesn't interfere with new page
  if (animator && typeof animator.resetFollowMouseClasses === 'function') animator.resetFollowMouseClasses();

  // sync check so vt names are set before the browser takes the snapshot
  if (vtOutOfView && typeof vtOutOfView.checkSync === 'function') vtOutOfView.checkSync();

  observerBlocker(); // so observers don't call resize while replacing content
};

// so observers don't call resize while animating, which slows down the animation
export const observerBlocker = () => {
  // console.log('observerBlocker');
  Resize.setBlockResizeObserver(true); 
  if (typeof fader !== 'undefined' && fader) fader.setBlockResizeObserver(true);
  if (typeof animator !== 'undefined' && animator) animator.blockResizeObserver = true;
};

export const observerUnblocker = () => {
  // console.log('observerUnblocker');  
  Resize.setBlockResizeObserver(false);
  Resize.setResize(true);

  if (typeof fader !== 'undefined' && fader) {
    fader.setBlockResizeObserver(false);
    fader.setFaders();
  }
  
  if (typeof animator !== 'undefined' && animator) {
    animator.blockResizeObserver = false;
    animator.resizeHandler(true);
  } 
}

// const frameHandler = () => {
//   // console.log('frameHandler');

//   // browser color
//   if (browserColorEl) {
//     const background = getComputedStyle(browserColorEl).getPropertyValue('background-color');
//     document.querySelector('meta[name="theme-color"]').setAttribute('content', background);
//   }
// };
